module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCIgY2xhc3M9ImRlc2lnbi1pY29uZm9udCI+CiAgPHBhdGggZD0iTTkgMC41QTguNSA4LjUgMCAxIDAgOSAxNy41QTguNSA4LjUgMCAxIDAgOSAwLjVaIiBmaWxsPSIjRkZGIiBzdHJva2U9IiNCMkIyQjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/check-white.svg
// module id = dgYD
// module chunks = 167